import React from "react";
import { Button, Icon } from "semantic-ui-react";

const additionHelpers = (handleAddition, isCustomer = true) => {
  const additionLabel = (
    <>
      <span className="pr-1">
        Don't see the correct {isCustomer ? "customer" : "officer"}?
      </span>
      <Button type="button" positive onClick={handleAddition}>
        <Icon name="plus" />
        Add
      </Button>
    </>
  );

  const additionButton = (
    <>
      <Button type="button" positive onClick={handleAddition}>
        Add
      </Button>
    </>
  );

  return { additionLabel, additionButton };
};

export default additionHelpers;
